import React from 'react';

import { RichTextHeadline } from 'components/Text';

export function SignUpBlockHeadline({
  text,
  isPageHeader,
}: {
  text: string;
  isPageHeader: boolean;
}) {
  return (
    <RichTextHeadline
      tag={isPageHeader ? 'h1' : undefined}
      styleAs={isPageHeader ? 'h2' : undefined}
    >
      {text}
    </RichTextHeadline>
  );
}
